import React, { ReactNode } from 'react';

import s from './GraphTooltip.module.sass';

type TooltipProps = {
  title?: string
  time?: string
  price?: ReactNode
};

const GraphTooltip = React.forwardRef<HTMLDivElement, TooltipProps>((
  {
    title,
    time,
    price,
  },
  ref,
) => (
  <div
    className={s.root}
    ref={ref}
    style={{ display: !time || !price ? 'none' : 'flex' }}
  >
    {time && price && (
      <>
        <span className={s.date}>
          {time}
        </span>
        {title && (
          <span className={s.price}>
            {title}
            :
            {' '}
            {price}
          </span>
        )}
      </>
    )}
  </div>
));

export default GraphTooltip;
